import { render, staticRenderFns } from "./appointDetail.vue?vue&type=template&id=39dfcbca&scoped=true&"
import script from "./appointDetail.vue?vue&type=script&lang=js&"
export * from "./appointDetail.vue?vue&type=script&lang=js&"
import style0 from "./appointDetail.vue?vue&type=style&index=0&id=39dfcbca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dfcbca",
  null
  
)

export default component.exports